import { useQuery } from "@tanstack/react-query";
import { BASE_URL } from "utils/constant";

export const getImageUrl = async (mediaId) => {
    if (!mediaId) return null;
    try {
        const accessToken = localStorage.getItem("access");
        const response = await fetch(`${BASE_URL}/core/api/snag/${mediaId}/`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });
        if (response.ok) {
            const data = await response.json();
            return data.data; // Assuming the API returns an image URL
        } else {
            console.error("Failed to fetch media URL:", response.statusText);
            return null;
        }
    } catch (error) {
        console.error("Error fetching media URL:", error);
        return null;
    }
};

export const useImageUrl = (mediaId) => {
    return useQuery({
        queryKey: ["imageUrl", mediaId],
        queryFn: () => getImageUrl(mediaId),
        enabled: !!mediaId,
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 10 * 60 * 1000, // 10 minutes
        retry: 2,
    });
};
